import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { DropDownInput1 } from "../../../components/_input/_dropdown1";
import { DropDownInput } from "../../../components/_input/_dropdown";
import { TextArea } from "../../../components/_input/_textArea";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import config from '../../../configuration/config.json';
import { FormButton } from "../../../components/_input/_button";
import { Price } from "../../../components/__simple/_price";
import SectionHeading from "../../../components/sectionHeading";
import { addToCart } from "../../../_functions/cart";

import { getData, User_Data_Key } from "../../../utils/localStorageManager";
import { formValidate, GetMessages } from "../../../utils/validation";
import { includes } from "lodash";
import { toast } from "react-toastify";
import Joi from "joi";
export function ServiceOrder({ data }) {
    const { t: trans, i18n } = useTranslation(["info"]);
    const { path } = useRouteMatch();

    //--------------------------------------------------
    const [maintenanceObj, setMaintenanceObj] = useState({
        showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
    });
    const [Defult, setDefult] = useState({
        showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
    });
    //selected option 
    const [selMain, setselMain] = useState({ ID: "0", desAr: trans("info:main_service"), desEn: "chose" });
    const [selsub1, setselsub1] = useState({ ID: "0", desAr: trans("info:sub_main_service"), desEn: "chose" });
    const [selsub2, setselsub2] = useState({ ID: "0", desAr: trans("info:main_service_type"), desEn: "chose" });

    const [isLodingMain, setIsLodingMain] = useState(false);
    const [isLodingsub1, setIsLodingsub1] = useState(false);
    const [isLodingsub2, setIsLodingsub2] = useState(false);
    const [isLodingService, setIsLodingService] = useState(false);

    const [infoPrice, setinfoPrice] = useState([{ Price: 0 }]);
    useEffect(() => {
        console.log("handleServiceOrder:", data);
        handleServiceOrder(data);
    }, [data]);

    const [requestForm, setRequestForm] = useState({
        mainServiceID: '',
        subServiceID: '',
        typeServiceID: '',
        serciveID: '',
        siteID: ''
    });

    const schema = Joi.object({
        mainServiceID: Joi.string().required().messages(GetMessages()),
        subServiceID: Joi.string().required().messages(GetMessages()),
        typeServiceID: Joi.string().required().messages(GetMessages()),
        serciveID: Joi.string().required().messages(GetMessages()),
        siteID: Joi.string().required().messages(GetMessages()),

    });
    // to remove the unneeded props
    const removeUnspecificError = (errorList, values = []) => {
        let errorResult = {};
        if (values?.length > 0) {
            const lowerValues = values.map(item => {
                return item.toLowerCase()
            });
            Object.assign(errorResult, errorList);
            if (errorList) {
                for (let index = 0; index < Object.keys(errorList).length; index++) {
                    const key = Object.keys(errorList)[index];
                    if (includes(lowerValues, key.toLowerCase())) {
                        delete errorResult[key];
                    } else {
                        continue;
                    }
                }
            }
        }
        return errorResult;
    };



    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState({});
    // to sumbit finance car order
    const handleSubmit = () => {

        setIsLoading(true);
        try {
            setTimeout(

                () => {
                    const val = { ...requestForm };
                    val.mainServiceID = MainServiceID;
                    val.subServiceID = subServiceID;
                    val.typeServiceID = TypeServiceID;
                    val.serciveID = SerciveID;
                    setRequestForm(val);

                    const result = formValidate(schema, requestForm) ?? {};
                    let unspesificErrors = null;
                    let newErrors = {};
                    newErrors = unspesificErrors ? removeUnspecificError(result, unspesificErrors) : result;
                    setError(newErrors);
                    if (Object.keys(newErrors).length === 0) {

                        const isLogin = getData('isAuthenticated')
                        if (!isLogin) {
                            setVehicales([]);
                            toast.error(trans("info:login_to_get_my_cars"));
                            return;
                        }
                        const cleanData = JSON.parse(getData(User_Data_Key, true));
                        if (cleanData.custID) {

                            SendResreve(VIN, MainServiceID, subServiceID, TypeServiceID, SerciveID, modelCode, cleanData.custID, infoPrice[0].Price);
                        } else {
                            toast.error(trans("info:approveAccount"));
                        }



                    }

                    setIsLoading(false);
                }


                , 1000);

        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };

    const handleServiceOrder = (data) => {

        try {


            setinfoPrice([{ Price: 0 }]);
            const value = { ...maintenanceObj, ...data };


            setDefult(data);


            GetVehicales();
            fetchMainService(data);
            GetBranch();

            setSubService1([]);
            setSubService2([]);
            setService([]);

            if (value.type === "order") {


            }
            if (value.type === 'main') {
                var main = { value: data.main, sub1: data.sub1 }
                fetchSubService(data);

            } else if (value.type === 'sub1') {
                var main = { value: data.main }
                fetchSubService(data);
                var sub1 = { value: data.sub1 }
                fetchSubService2(data);

            } else if (value.type === 'sub2') {
                var main = { value: data.main }
                fetchSubService(data);
                var sub1 = { value: data.sub1 }
                fetchSubService2(data);
                var sub2 = { value: data.sub2 }
                fetchService(sub2);


            }
            setTimeout(() => { setMaintenanceObj(value) }, 2000);


        } catch (e) {
            console.error(e)

        }





    };
    const [Note, setNote] = useState("");

    const [lang, setlang] = useState(localStorage.getItem('i18nextLng'));
    const [MainServic, setMainServic] = useState([]);


    function fetchMainService(opiton) {

        setIsLodingMain(true);
        setTimeout(setMainServic([]), 100);
        setTimeout(setSubService1([]), 100);
        setTimeout(setSubService2([]), 100);
        setTimeout(setService([]), 100);

        axios.request({
            url: config.controllerUrl + 'api/MaintenancePages/GetMainServicesReq',
            method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log(response.data.ApiObjectData);
                // const val = { ...requestForm };
                // val.subServiceID = null;
                // val.typeServiceID = null;
                // val.serciveID = null;
                // setRequestForm(val);
                setTimeout(setMainServic(response.data), 100);
                setIsLodingMain(false);

                console.log("fetchMainService opiton:", opiton);
                if (opiton.main)
                    response.data.map((B) => {
                        if (B.MainServiceID === opiton.main) {
                            // const v = selMain;
                            // v.desAr = B.DescriptionAr;
                            // v.desEn = B.DescriptionEn;
                            // v.ID = B.MainServiceID;

                            // setselMain(v);
                            console.log("Defult.main", opiton.main);
                            //console.log(v);

                            setMainServiceID(opiton.main);
                        }
                    })

            })
            .catch(function (error) {
                setIsLodingMain(false);
                console.log(error);
            });



    }
    const [SubService1, setSubService1] = useState([]);
    function fetchSubService(option) {

        setIsLodingsub1(true);
        setSubServiceID(null);
        setTypeServiceID(null);
        setSerciveID(null);
        // const val = { ...requestForm };
        // val.subServiceID = null;
        // val.typeServiceID = null;
        // val.serciveID = null;
        // setRequestForm(val);
        setTimeout(setSubService1([]), 100);
        setTimeout(setSubService2([]), 100);
        setTimeout(setService([]), 100);

        axios.request({
            url: config.controllerUrl + 'api/MaintenancePages/GetSubService1',
            data: { id: option.main ? option.main : option.value }, method: "POST", responseType: "json"
        })
            .then(function (response) {


                setTimeout(setSubService1(response.data), 1000);
                setIsLodingsub1(false);

                if (option.sub1) {
                    response.data.map((B) => {
                        if (B.SubService1ID === option.sub1) {
                            // const v = selsub1;
                            // v.desAr = B.DescriptionAr;
                            // v.desEn = B.DescriptionEn;
                            // v.ID = B.SubService1ID;
                            // setselsub1(v);
                            console.log("Defult.sub1", option.sub1);

                            setSubServiceID(option.sub1);
                        }
                    }

                    )
                }


            })
            .catch(function (error) {
                setIsLodingsub1(false);
                console.log(error);
            });



    }
    const [SubService2, setSubService2] = useState([]);


    function fetchSubService2(option) {

        setIsLodingsub2(true);
        // const val = { ...requestForm };
        // val.typeServiceID = null;
        // val.serciveID = null;
        // setRequestForm(val);
        setTypeServiceID(null);
        setSerciveID(null);
        setTimeout(setSubService2([]), 100);
        setTimeout(setService([]), 100);

        axios.request({
            url: config.controllerUrl + 'api/MaintenancePages/GetSubService2',
            data: { id: option.sub1 ? option.sub1 : option.value }, method: "POST", responseType: "json"
        })
            .then(function (response) {

                setTimeout(setSubService2(response.data), 100);
                setIsLodingsub2(false);

                if (option.sub2) {
                    response.data.map((B) => {
                        if (B.SubService2ID === option.sub2) {
                            // const v = selsub2;
                            // v.desAr = B.DescriptionAr;
                            // v.desEn = B.DescriptionEn;
                            // v.ID = B.SubService2ID;
                            // setselsub2(v);
                            //console.log(v);
                            console.log("Defult.sub2", option.sub2);

                            setTypeServiceID(option.sub2);
                        }
                    })
                }

            })
            .catch(function (error) {
                setIsLodingsub2(false);
                console.log(error);
            });



    }
    const [Service, setService] = useState([]);


    function fetchService(option) {

        setIsLodingService(true);
        // const val = { ...requestForm };
        // val.serciveID = null;
        // setRequestForm(val);
        setSerciveID(null);
        setTimeout(setService([]), 100);

        axios.request({
            url: config.controllerUrl + 'api/MaintenancePages/GetServices',
            data: { id: option.value }, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log(response.data.ApiObjectData);

                setTimeout(setService(response.data), 100);
                setIsLodingService(false);
            })
            .catch(function (error) {
                console.log(error);
                setIsLodingService(false);
            });



    }
    const [Branches, setBranches] = useState([]);

    let [modelCode, setmodelCode] = useState("");
    let [VIN, setVIN] = useState("");

    const [SerciveID, setSerciveID] = useState(null);
    const [MainServiceID, setMainServiceID] = useState(null);
    const [subServiceID, setSubServiceID] = useState(null);
    const [TypeServiceID, setTypeServiceID] = useState(null);
    function FetchPrice(modelC, SID) {

        if (!modelC) return;
        if (!SID) return;

        axios.request({
            url: config.controllerUrl + 'api/MaintenancePages/GetPriceService',
            data: { modelCode: modelC, serviceId: SID }, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log(response.data.ApiObjectData);

                setinfoPrice(response.data);


            })
            .catch(function (error) {
                setinfoPrice([{ Price: 0 }]);

                console.log(error);
            });


    }


    useEffect(() => {
        const val = { ...requestForm };
        val.mainServiceID = MainServiceID;
        val.subServiceID = subServiceID;
        val.typeServiceID = TypeServiceID;
        val.serciveID = SerciveID;
        setRequestForm(val);
    }, [MainServiceID, subServiceID, TypeServiceID, SerciveID]);

    function SendResreve(VIN, MainServiceID, subServiceID, TypeServiceID, ServecID, ModelCode, UserID, Amount) {



        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = {
            "VIN": VIN,
            "UserID": UserID,
            "Amount": Amount ? Amount : 0,
            "ModelCode": ModelCode,
            "MainServiceID": MainServiceID,
            "subServiceID": subServiceID,
            "TypeServiceID": TypeServiceID,
            "ServiceID": ServecID,
            "Note": Note
        };


        axios.request({
            url: "/api/Service/Service", headers: myHeaders,
            data: raw, method: "POST", responseType: "json"
        }).then(function (response) {
            console.log("Service", response.data)


            toast.success(trans("info:reservation_completed_successfully"));

        }
        ).then((response) => {
            console.log('Error', response);
        })
            .catch(error => console.log('error', error));
    }



    async function GetBranch() {

        await axios.request({
            url: config.controllerUrl + 'api/Branches/GetBranches',
            method: "POST", responseType: "json"
        })
            .then(function (response) {

                setBranches(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });


    }


    const [Vehicales, setVehicales] = useState([]);


    async function GetVehicales() {
        try {
            const isLogin = getData('isAuthenticated')
            if (!isLogin) {
                setVehicales([]);
                toast.error(trans("info:login_to_get_my_cars"));
                return;
            }
            const cleanData = JSON.parse(getData(User_Data_Key, true));

            if (!cleanData.custID) {
                setVehicales([]);
                toast.error(trans("info:approveAccount"));
                return;
            }
            console.log('cleanData', cleanData);
            const Body = {
                "name": "site_fetchMyVehical",
                "values": {
                    "CustID": Number(cleanData.custID)
                }
            };
            await axios.request({
                url: config.baseURLSadad + 'func',
                data: Body, method: "POST", responseType: "json"
            })
                .then(function (response) {

                    setVehicales(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        } catch (error) {
            console.log(error);
        }



    }


    return (

        <div className="mainteance-popup">
            <div className="mainteance-popup-container p-4">
                <div className="mainteance-popup-container-header">
                    <SectionHeading
                        title={trans("info:price")}
                        infoText={trans("info:service_price_head_message")}
                    >
                        <div className='p-4 mt-4 text-20 text-primary'>
                            {infoPrice.map((p, index) => {
                                return (<Price key={index} price={p.Price} />);
                            })}

                        </div>

                    </SectionHeading>
                </div>
                <div className="my-20 px-8">


                    <div className="grow  input basis-1/2">
                        <DropDownInput

                            className={"  "}
                            fieldTextClass={"text-30 text-gray-mid"}
                            classDropdownField={"border-none nice-shadow-2 border-radius-sm "}
                            styles={{ height: "8rem" }}
                            // errorLabel={error?.job}
                            defaultOption={{ value: 0, text: (lang == 'en' ? 'The vehicle you want to service' : 'المركبة التي تريد صيانتها') }}
                            options={[
                                ...Vehicales.map(B => {
                                    return { value: B.SN, text: lang === 'ar' ? B.carAr : B.carEn, ModelCode: B.ModelCode };
                                })]}
                            onfilter={(option) => {
                                setmodelCode(option.ModelCode);
                                setVIN(option.value);
                                FetchPrice(option.ModelCode, SerciveID);
                            }}
                        />
                    </div>



                    <div className="grow  input basis-1/2">
                        <DropDownInput
                            isLoading={isLodingMain}
                            className={"  "}
                            fieldTextClass={"text-30 text-gray-mid"}
                            classDropdownField={"border-none nice-shadow-2 border-radius-sm "}
                            styles={{ height: "8rem" }}
                            errorLabel={error?.mainServiceID}
                            selectedValue={MainServiceID}
                            defaultOption={{ value: selMain.ID, text: (lang == 'en' ? selMain.desEn : selMain.desAr) }}
                            options={[
                                ...MainServic.map(B => {
                                    return { value: B.MainServiceID, text: lang === 'ar' ? B.DescriptionAr : B.DescriptionEn };
                                })]}
                            onfilter={(option) => {
                                fetchSubService(option);
                                setMainServiceID(option.value);
                                const val = { ...requestForm };
                                val.mainServiceID = option.value;
                                setRequestForm(val);
                                setMainServiceID(option.value);




                            }}
                        />
                    </div>



                    <div className="grow  input basis-1/2">
                        <DropDownInput
                            isLoading={isLodingsub2}
                            className={"  "}
                            fieldTextClass={"text-30 text-gray-mid"}
                            classDropdownField={"border-none nice-shadow-2 border-radius-sm "}
                            styles={{ height: "8rem" }}
                            errorLabel={error?.subServiceID}
                            selectedValue={subServiceID}
                            defaultOption={{ value: selsub1.ID, text: (lang == 'en' ? selsub1.desEn : selsub1.desAr) }}
                            options={[
                                ...SubService1.map(B => {

                                    return ({ value: B.SubService1ID, text: lang === 'ar' ? B.DescriptionAr : B.DescriptionEn });


                                })]}
                            onfilter={(option) => {
                                fetchSubService2(option);
                                const val = { ...requestForm };
                                val.subServiceID = option.value;
                                setRequestForm(val);
                                setSubServiceID(option.value);

                            }}
                        />
                    </div>



                    <div className="grow  input basis-1/2">
                        <DropDownInput
                            isLoading={isLodingsub1}
                            className={"  "}
                            fieldTextClass={"text-30 text-gray-mid"}
                            classDropdownField={"border-none nice-shadow-2 border-radius-sm "}
                            styles={{ height: "8rem" }}
                            errorLabel={error?.typeServiceID}
                            selectedValue={TypeServiceID}
                            defaultOption={{ value: selsub2.ID, text: (lang == 'en' ? selsub2.desEn : selsub2.desAr) }}
                            options={[
                                ...SubService2.map(B => {
                                    return { value: B.SubService2ID, text: lang === 'ar' ? B.DescriptionAr : B.DescriptionEn };
                                })]}
                            onfilter={(option) => {
                                fetchService(option);
                                const val = { ...requestForm };
                                val.typeServiceID = option.value;
                                setRequestForm(val);
                                setTypeServiceID(option.value);

                            }}
                        />
                    </div>



                    <div className="grow  input basis-1/2">
                        <DropDownInput
                            isLoading={isLodingService}
                            className={"  "}
                            fieldTextClass={"text-30 text-gray-mid"}
                            classDropdownField={"border-none nice-shadow-2 border-radius-sm "}
                            styles={{ height: "8rem" }}
                            errorLabel={error?.serciveID}
                            selectedValue={SerciveID}
                            defaultOption={{ value: 0, text: (lang == 'en' ? "service" : "الخدمة") }}
                            options={[
                                ...Service.map(B => {
                                    return { value: B.ServiceID, text: lang === 'ar' ? B.ServiceName : B.ServiceName };
                                })]}
                            onfilter={(option) => {
                                FetchPrice(modelCode, option.value);
                                const val = { ...requestForm };
                                val.serciveID = option.value;
                                setRequestForm(val);
                                setSerciveID(option.value);


                            }}
                        />
                    </div>


                    <div className="grow  input basis-1/2">
                        <DropDownInput
                            className={"  "}
                            fieldTextClass={"text-30 text-gray-mid"}
                            classDropdownField={"border-none nice-shadow-2 border-radius-sm "}
                            styles={{ height: "8rem" }}
                            errorLabel={error?.siteID}
                            defaultOption={{ value: 0, text: (lang == 'en' ? "branch" : "الفرع") }}
                            options={[
                                ...Branches.map(B => {
                                    return { value: B.SiteID, text: lang === 'ar' ? B.DescriptionAr : B.DescriptionEn };
                                })]}
                            onfilter={(option) => {
                                const val = { ...requestForm };
                                val.siteID = option.value;
                                setRequestForm(val);

                            }}
                        />
                    </div>

                    <div className="grow mb-10">
                        <TextArea
                            row={5}
                            className={"border-none nice-shadow-2 border-radius-sm"}
                            title={trans("info:note")}
                            onChangeValue={(data) => {
                                setNote(data);
                            }}
                        />

                    </div>

                    <div className=" flex flex-row nice-gap-2rem">

                        <div className=" basis-2/4 my-5 order-1 ">
                            <div className="nice-bg-btn-2 bg-gray text-24 text-white gap-3r text-30" onClick={() => {

                                if (infoPrice[0].Price) {
                                    addToCart(
                                        {
                                            id: VIN + '-' + SerciveID,
                                            ProductID: SerciveID,
                                            name: VIN,
                                            price: infoPrice[0].Price,
                                            Type: "service",

                                        }
                                    )
                                } else {
                                    toast.warning(trans("info:can_reserve_service"));

                                }
                            }
                            }>
                                {trans("info:add_to_cart")} <img src="/assets/icons/cart.svg" className="filtter-primary" />
                            </div>
                        </div>
                        <div className="basis-2/4 my-5 ">
                            {/* <div className="nice-bg-btn-2 bg-primary text-white text-30" onClick={() => {

                                handleSubmit();

                            }}>
                                {trans("info:reserve")}
                            </div> */}

                            <FormButton
                                classes={"nice-bg-btn-2 bg-primary text-white text-30"}
                                isLoading={isLoading}
                                style={{ minHeight: "7rem" }}
                                onClick={handleSubmit}
                                name={trans("info:reserve")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}